export default "__VITE_ASSET__ffjd20BZfghNiCzGd8o8YQ__";